import { MessageDescriptor } from 'react-intl';
import { GQL } from '@gin-betting/core';
import { BannerZoneLocation, TimePeriod } from '@gin-betting/constants';

import { MobileWidgetType } from './types';
import globalMsgs from 'messages';

export const NAME = 'promo' as const;

export const GET_TOP_TOURNAMENTS_REQUEST = `promo/GET_TOP_TOURNAMENTS:REQUEST` as const;
export const GET_TOP_TOURNAMENTS_SUCCESS = `promo/GET_TOP_TOURNAMENTS:SUCCESS` as const;
export const GET_TOP_TOURNAMENTS_FAIL = `promo/GET_TOP_TOURNAMENTS:FAIL` as const;
export const SET_TOP_TOURNAMENTS_SUCCESS = `promo/SET_TOP_TOURNAMENTS_SUCCESS` as const;

export const GET_MISSING_MATCHES_REQUEST = `promo/GET_MISSING_MATCHES:REQUEST` as const;
export const GET_MISSING_MATCHES_SUCCESS = `promo/GET_MISSING_MATCHES:SUCCESS` as const;
export const GET_MISSING_MATCHES_FAIL = `promo/GET_MISSING_MATCHES:FAIL` as const;

export const GET_MATCHES_SUCCESS = 'promo/GET_MATCHES_SUCCESS' as const;

export const DEFAULT_TOURNAMENTS_SIZE = 5;

export const ALL = 'all' as const;

export const WIDGETS = ['weekly', 'monthly'] as const;

export const MOBILE_WIDGETS = ['daily', 'weekly', 'monthly'] as const;

export const MARKETS_ACTIVE_STATUSES: GQL.MarketStatus[] = [
    GQL.MarketStatus.ACTIVE,
    GQL.MarketStatus.SUSPENDED,
];

export const MARKET_LIMIT = 3 as const;

export const NUMBER_OF_ROWS = 5;

export const ZONE_LOCATIONS = [
    BannerZoneLocation.TOP_SPORT_EVENTS,
    BannerZoneLocation.POPULAR_SPORT_EVENTS,
    BannerZoneLocation.FAVORITES_SPORT_EVENTS,
] as const;

export const MAPPING_ZONE = {
    [BannerZoneLocation.POPULAR_SPORT_EVENTS]: globalMsgs.popular,
    [BannerZoneLocation.TOP_SPORT_EVENTS]: globalMsgs.top,
    [BannerZoneLocation.FAVORITES_SPORT_EVENTS]: globalMsgs.favorites,
};

export const MAPPING_PERIOD: {
    [key in MobileWidgetType]: MessageDescriptor;
} = {
    daily: globalMsgs.daily,
    weekly: globalMsgs.weekly,
    monthly: globalMsgs.monthly,
};

export const MOBILE_TOP_MATCH_LIST_INDEX_CONFIG: {
    [key in MobileWidgetType]: number;
} = {
    daily: TimePeriod.Daily,
    weekly: TimePeriod.Weekly,
    monthly: TimePeriod.Monthly,
};

export const matchPropsToPick = [
    'id' as const,
    'marketsCount' as const,
    'sportId' as const,
    'score' as const,
    'tournament' as const,
    'startTime' as const,
    'streams' as const,
    'status' as const,
    'liveCoverage' as const,
    'slug' as const,
    'meta' as const,
];

export const marketPropsToPick = [
    'id' as const,
    'name' as const,
    'odds' as const,
];

export const oddsPropsToPick = [
    'id' as const,
    'name' as const,
    'competitorId' as const,
];

export const tournamentPropsToPick = [
    'id' as const,
    'name' as const,
    'slug' as const,
];
